import React from "react";

import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";
import { StaffSelection } from "@/components/Filter/staffSelection";

export default function MutiLocationFormRow({
  mutiLocationFormData,
  setMutiLocationFormData,
  staffOptions,
}) {
  return (
    <React.Fragment>
      <Box component="section" spacing={2} sx={{ paddingX: 10 }}>
        <Stack
          sx={{ my: 2 }}
          direction={"row"}
          divider={<Divider orientation="vertical" flexItem variant="middle" />}
          spacing={5}
        >
          <Box sx={{ flex: 1, display: "flex", justifyContent: "center" }}>
            <StaffSelection
              formDetail={mutiLocationFormData}
              setFormDetail={setMutiLocationFormData}
              staffOptions={staffOptions}
            ></StaffSelection>
          </Box>
        </Stack>
      </Box>
    </React.Fragment>
  );
}
